export default {
    create_dealer_create_title: 'Crear un distribuidor',
    create_dealer_edit_title: 'Editar distribuidor',
    create_dealer_the_dealer_was_created: 'El distribuidor fue creado',
    create_dealer_dealer_name: 'Nombre de el distribuidor',
    create_dealer_dealer_name_min_error: 'El nombre de el distribuidor debe contener un mínimo de caracteres',
    create_dealer_dealer_name_max_error: 'El nombre de el distribuidor contiene un máximo de caracteres',
    create_dealer_language: 'Lenguaje',
    create_dealer_time_zone: 'Zona Horaria',
    create_dealer_brand: 'Marca',
    create_dealer_crm: 'Id. de Salesforce',
    create_dealer_crm_min_error: 'El CRN debe contener un mínimo de caracteres',
    create_dealer_internal: 'Interno',
    create_dealer_yes: 'Si',
    create_dealer_not: 'No',
    create_dealer_username: 'Usuario',
    create_dealer_username_error_min: 'El nombre de usuario debe contener un mínimo de caracteres',
    create_dealer_username_error_max: 'El nombre de usuario debe contener un máximo de caracteres',
    create_dealer_email: 'Correo',
    create_dealer_password: 'Contraseña',
    create_dealer_role: 'Rol',
    create_dealer_report_options: 'Opciones de informe',
    create_dealer_site_options: 'Opciones del sitio',
    create_dealer_no_options: 'Sin opciones',
    create_dealer_the_dealer_has_been_edited: 'El distribuidor ha sido editado',
    create_dealer_general: 'General',
    create_dealer_packages: 'Paquetes',
    create_dealer_automatic: 'Automático',
    create_dealer_manual: 'Manual',
    create_dealer_click_to_copy_password: 'Haga clic para copiar la contraseña!',
    create_dealer_the_password_was_copied: 'La contraseña fue copiada',
    create_dealer_package: 'Paquete',
    create_dealer_select: 'Seleccionar...',
    create_dealer_crm_max_error: 'El Id. de Salesforce debe contener un máximo de caracteres',
    create_dealer_promiles_username: 'Nombre de usuario de Promiles',
    create_dealer_promiles_email: 'Correo electrónico de Promiles',
    create_dealer_fuel_card_company_code: 'Código de la tarjeta de combustible',
    create_dealer_additional_info: 'Información Adicional',
    create_dealer_error_username: 'El nombre de usuario debe contener sólo letras minúsculas y números, los espacios no son válidos',
    create_dealer_verify_terms_conditions: 'Verificar los términos y condiciones',
    create_dealer_verify_terms_conditions_message: 'Al activar esta opción (SÍ) se requiere por parte de los usuarios la aceptación de términos y condiciones durante el proceso de autenticación. Una vez aceptados los T&C, el sistema no vuelve a solicitarlo',
    create_dealer_speed_limit_engine: 'Límite de velocidad del motor',
    create_dealer_rgeo_engine: 'Motor Rgeo',
    create_dealer_osm_with_fallback_google: "OSM con acceso a Google",
    create_dealer_osm_only: "Sólo OSM",
    create_dealer_web_service_integration: "WEX EFS",
    create_dealer_status: "Estado",
    create_dealer_validate_credentials: "Validar Credenciales",
    create_dealer_active: "Activo",
    create_dealer_inactive: "Inactivo",
    create_dealer_fuel_card_integrations: "Integración de tarjetas de combustible",
    create_dealer_wex_credencials_success: "Las credenciales son válidas",
    create_dealer_wex_credencials_error: "Las credenciales no son válidas",
    create_dealer_wex_credencials_message: "Las credenciales deben validarse",
    create_dealer_promiles: "Promiles",
    create_dealer_fuel_cards: "Tarjetas de combustible",
    create_dealer_web_services_status: "Estado de Servicios Web",
    create_dealer_master_company: "Compañía Maestra",
    create_delaer_brand: "Marca",
};